/**
 * Apertura degli accordion della PDP differenziata per viewport.
 *
 * IB-656 (feedback Sara, 18/08): "il dropdown promo espanso da mobile occupa
 * troppo spazio e nasconde colore e taglie". Il blocco promo nasce aperto
 * perche' il suo setting "Open by default" e' attivo, scelta sensata su
 * desktop, dove lo spazio c'e', ma su mobile spinge sotto la piega i selettori
 * di variante, che sono il vero contenuto della scheda.
 *
 * Invece di togliere l'apertura ovunque - decisione che spetta a chi configura
 * il tema - si riusa la convenzione gia' adottata dai filtri di collezione:
 * `data-expand-desktop` e `data-expand-mobile` sui <details>. Il setting resta
 * la fonte per il desktop, mentre su mobile l'accordion parte chiuso.
 *
 * La logica dei filtri vive in facet-filters.js, che non e' caricato nella
 * scheda prodotto: qui e' replicata sugli stessi attributi, cosi' il markup
 * resta coerente fra le due pagine.
 */
(() => {
  const MOBILE = '(max-width: 1023px)';

  function applica() {
    const mobile = window.matchMedia(MOBILE).matches;
    document.querySelectorAll('details[data-expand-desktop][data-expand-mobile]').forEach((det) => {
      // Se l'utente ha gia' interagito, la sua scelta vince: non la si sovrascrive
      // a ogni cambio di viewport.
      if (det.dataset.userToggled === 'true') return;
      det.open = (mobile ? det.dataset.expandMobile : det.dataset.expandDesktop) === 'true';
    });
  }

  function avvia() {
    document.querySelectorAll('details[data-expand-desktop][data-expand-mobile]').forEach((det) => {
      det.addEventListener('toggle', () => {
        det.dataset.userToggled = 'true';
      });
    });
    applica();

    // Solo al superamento del breakpoint, non a ogni resize.
    const mq = window.matchMedia(MOBILE);
    if (mq.addEventListener) mq.addEventListener('change', applica);
    else mq.addListener(applica);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia, { once: true });
  } else {
    avvia();
  }
})();
